import React from "react";

export default function SQL_IS_NOT_NULL() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_IS_NOT_NULL</h1>
      <p>This is the SQL_IS_NOT_NULL component generated from the SQL JSON.</p>
    </div>
  );
}
